// src/pages/Auth/components/OtpStep.js

import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { LOADING_STATES } from '../constants';
import { StyledButton, StyledInput } from '../styles/Styles';


const OtpStep = ({ email, otp, setOtp, loadingState, onSubmit, onBack, isDarkMode }) => {
  const isLoading = loadingState === LOADING_STATES.OTP;

  return (
    <form onSubmit={onSubmit}>
      <Box>
        <Box 
          sx={{ 
            mb: 3,
            p: 2,
            backgroundColor: isDarkMode ? "#0a1020" : "#f0fdfa",
            borderRadius: "10px",
            border: `1px solid ${isDarkMode ? "#2d2d3f" : "#ccfbf1"}`,
            textAlign: "center"
          }}
        >
          <Typography variant="body2" sx={{ color: isDarkMode ? "#a0aec0" : "text.secondary", fontSize: "14px" }}>
            Code sent to
          </Typography>
          <Typography variant="body1" fontWeight="600" sx={{ color: "#219297", mt: 0.5 }}>
            {email}
          </Typography>
        </Box>
        
        <Box mb={3}>
          <Typography 
            component="label" 
            htmlFor="otp-input"
            sx={{ 
              fontSize: "14px", 
              fontWeight: "600", 
              marginBottom: "8px", 
              display: "block",
              color: isDarkMode ? "#e2e8f0" : "#374151"
            }}
          >
            Verification Code
          </Typography>
          <StyledInput
            id="otp-input"
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
            required
            placeholder="Enter 6-digit code"
            maxLength={6}
            isDarkMode={isDarkMode}
            sx={{
              fontSize: "18px",
              fontFamily: "monospace",
              letterSpacing: "0.3em",
              textAlign: "center",
              fontWeight: "600",
            }}
          />
        </Box>

        <StyledButton
          type="submit"
          variant="contained"
          fullWidth
          disabled={isLoading}
          isDarkMode={isDarkMode}
        >
          {isLoading ? (
            <Box display="flex" alignItems="center" justifyContent="center">
              <CircularProgress size={20} sx={{ color: "white", mr: 1.5 }} />
              Verifying code...
            </Box>
          ) : (
            "Verify & Continue"
          )}
        </StyledButton>

        <Button
          variant="text"
          fullWidth
          onClick={onBack}
          sx={{
            mt: 2,
            color: "#219297",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "14px",
            "&:hover": {
              backgroundColor: isDarkMode ? "#2d2d3f" : "#f0fdfa",
            },
          }}
        >
          ← Change Email Address
        </Button>
      </Box>
    </form>
  );
};

export default React.memo(OtpStep);